import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle
} from 'reactstrap';
import * as commonActions from '@common/common.action';
import { useDispatch } from 'react-redux';
import IntlMessage from '../../../../../../helpers/intlMessage';

export default function ModalInformacao(props) {
  const [modalAberto, setModalAberto] = useState(false);
  const backdrop = !props.backdrop ? false : props.backdrop;
  const keyboard = props.keyboard === undefined ? true : props.keyboard;
  const dispatch = useDispatch();

  useEffect(() => {
    setModalAberto(props.showModalInformacao);
    dispatch(commonActions.showModal(props.showModalInformacao));
  }, [props.showModalInformacao]);

  function toggle() {
    setModalAberto(!modalAberto);
    dispatch(commonActions.showModal(!modalAberto));
    props.onModal(!modalAberto);
  }

  return (
    <React.Fragment>
      <div>
        <Modal
          className='modal-xl modal-informacao-requisicao'
          backdrop={backdrop}
          keyboard={keyboard}
          centered
          isOpen={modalAberto}
          toggle={toggle}
        >
          <ModalHeader toggle={!props.close ? toggle : props.close}>
            <IntlMessage id="general.materialArchiving.materialRequisitionRequestInformation" />
          </ModalHeader>

          <ModalBody style={{ maxHeight: '70vh', overflow: 'hidden scroll' }}>
            <div>
              {!!props.itensArquivadosAnteriormente.length &&
                props.itensArquivadosAnteriormente.map((item, index) => (
                  <Card key={index}>
                    <Row>
                      <Col lg={3}>
                        <CardBody>
                          <CardTitle>{`${item.numeroMaterial}`}</CardTitle>
                        </CardBody>
                      </Col>
                      <Col>
                        <CardBody>
                          <CardTitle>{`${<IntlMessage id="general.materialArchiving.description" />}: ${item.descricaoMaterial}`}</CardTitle>
                        </CardBody>
                      </Col>
                      <Col>
                        <CardBody>
                          <CardTitle>{`${<IntlMessage id="general.materialArchiving.filingDate" />}: ${item.dataArquivamento}`}</CardTitle>
                        </CardBody>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <CardBody>
                          <CardTitle>{`${item.localizacaoArquivamento}`}</CardTitle>
                        </CardBody>
                      </Col>
                    </Row>
                  </Card>
                ))}
            </div>
          </ModalBody>

          <ModalFooter>
            <Button
              onClick={!props.cancelar ? toggle : props.cancelar}
              className={`button-cancel`}
              color='secondary'
            >
              <IntlMessage id="general.materialArchiving.close" />
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Requisicao/modais/Informacao/index.js